module.exports = __webpack_public_path__ + "static/media/ChatbotLogo_Aero.26049726.svg";